import HideOnWebview from '@/components/webview/HideOnWebview';
import MainFooter from './Main';
import MiniFooter from './Mini';

type Props = {
  settings: LayoutProps['footer'];
};

const Footer = ({ settings }: Props) => {
  return (
    <HideOnWebview>{settings?.type === 'main' ? <MainFooter /> : <MiniFooter />}</HideOnWebview>
  );
};

Footer.defaultProps = {
  settings: {
    type: 'main',
  },
};

export default Footer;
